import { LinkBox, LinkOverlay } from "@chakra-ui/react"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Text from "@pathwright/ui/src/components/ui/Text"
import { WithCSS } from "@pathwright/ui/src/components/utils/styles"
import { getEstimatedTimeDisplay } from "@pathwright/utils/src/path/utils"
import Link from "@pathwright/ux/src/components/link/Link"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import { css } from "styled-components"
import { getStepVerbIcon } from "../../utils"

const PathStep = ({ step, getStepLinkProps, renderStepChevron, className }) => {
  const { t } = useTranslate()
  const metaParts = []
  if (step && step.is_required === false) metaParts.push("Optional")
  if (step && step.time_to_complete)
    metaParts.push(getEstimatedTimeDisplay(step.time_to_complete, t))
  if (step && step.userpoints_value)
    metaParts.push(`${step.userpoints_value} Points`)

  const stepLinkProps = getStepLinkProps?.(step.source_id) ?? {}
  const { to, relativeTo, href, ...restStepLinkProps } = stepLinkProps
  const hasRouteTarget = Boolean(to || relativeTo || href)
  const stepVerbText = step.verb || step.step_verb
  const StepVerb = stepVerbText ? (
    <WithCSS as="span" css={styles.stepVerb} className="step-verb">
      {stepVerbText.charAt(0).toUpperCase() +
        stepVerbText.slice(1).toLowerCase()}
      :
    </WithCSS>
  ) : null

  const stepName = (
    <WithCSS
      as={Text.Body}
      css={styles.title}
      style={{ fontWeight: "700", fontSize: "16px", color: "#222" }}
    >
      {StepVerb}
      {step.name}
    </WithCSS>
  )

  return (
    <WithCSS
      as={LinkBox}
      css={styles.container}
      className={`PathStep ${className || ""}`}
      data-source-id={step.source_id}
      {...(!hasRouteTarget ? restStepLinkProps : {})}
    >
      <WithCSS as={Text.Meta} css={styles.icon} style={{ marginRight: 10 }}>
        {(step.verb || step.step_verb) && (
          <Pathicon icon={getStepVerbIcon(step.verb || step.step_verb)} />
        )}
      </WithCSS>
      <WithCSS as="div" css={styles.text}>
        {hasRouteTarget ? (
          <Link asChild {...stepLinkProps}>
            <LinkOverlay>{stepName}</LinkOverlay>
          </Link>
        ) : (
          stepName
        )}
        {metaParts.length > 0 ? (
          <WithCSS as={"small"} css={styles.meta}>
            {metaParts.join(" • ")}
          </WithCSS>
        ) : null}
      </WithCSS>
      {renderStepChevron?.({ step, stepLinkProps }) ?? null}
    </WithCSS>
  )
}

PathStep.displayName = "PathStep"

export default PathStep

const styles = {
  container: css`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 20px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    &:first-of-type {
      border-top: none;
    }
  `,
  icon: css`
    margin-right: 10px;
  `,
  text: css`
    display: flex;
    flex-direction: column;
    min-width: 0;
    overflow: hidden;
  `,
  stepVerb: css`
    color: #888;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 5px;
  `,
  title: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  meta: css`
    margin-top: 2px;
    color: #888;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 12px !important;
  `
}
